import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { trackWhatsAppContact } from "../helper/facebookPixel";

const ServiceDetails = ({ service }) => {
  if (!service) {
    // If no service data is passed, we can return null or a fallback
    return null;
  }

  // Destructure the fields from your CHAPA_SERVICES_DATA item
  const {
    title,
    description,
    images,
    checklist,
  } = service;

  // Use the first image as main, second and third images for the gallery
  // Fallbacks ensure we don't break if the array is shorter
  const mainImg = images?.[0] || "/assets/img/service/service-1-1.png";
  const secondImg = images?.[1] || "/assets/img/service/service-1-3.png";

  return (
    <div className="service-details-area space-top space-extra-bottom overflow-hidden">
      <Helmet>   
        {/* <!-- Basic SEO tags --> */}
        <title>{title} • Leal | Chapa y Pintura - Mecánica</title>
        <meta name="language" content="Spanish" />
        <meta name="author" content="www.lealchapaypintura.com" />
        <meta
          name="description"
          content={description}
        />
        <meta
          name="keywords"
          content="Reparación, Pintura, ITV, chapa y pintura, Automoviles, Motos, Mecánica, Rápida, Chapa, Pintura, Mairena Del Aljarafe, pisa, Sevilla"
        />
        <meta name="robots" content="index, follow" />
        <meta charset="UTF-8" />

        {/* <!-- Open Graph tags for better social media sharing --> */}
        <meta
          property="og:title"
          content={title + " • Leal | Chapa y Pintura - Mecánica"}
        />
        <meta
          property="og:description"
          content={description}
        />
        <meta property="og:image" content="%PUBLIC_URL%/favicon.ico" />
        <meta property="og:url" content="%PUBLIC_URL%" />
        <meta property="og:type" content="website" />

        {/* <!-- Twitter Card tags for better social media sharing --> */}
        <meta
          name="twitter:title"
          content="Leal | Chapa y Pintura - Reparación & Servicio Profesional para Automóviles"
        />
        <meta
          name="twitter:description"
          content={description}
        /> 

      </Helmet>
      <div className="container">
        <div className="row gx-40 flex-row-reverse">
          {/* MAIN COLUMN */}
          <div className="col-xxl-8 col-lg-7">
            <div className="service-page-single">

              {/* Main Text Content */}
              <div className="page-content">
                {/* Dynamic Title */}
                <h2 className="page-title">{title}</h2>

                {/* Single 'description' field displayed as one or more paragraphs */}
                <p className="mb-25">{description}</p>

                {/* Two images below the description */}
                <div className="row gy-30">
                  <div className="col-sm-6">
                    <div className="page-img">
                      <img src={secondImg} alt="LealChapayPintura.com" />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="page-img">
                      <img src={mainImg} alt="LealChapayPintura.com" />
                    </div>
                  </div>
                </div>

                {/* Checklist items from data */}
                {checklist && checklist.length > 0 && (
                  <div className="checklist style2 mt-35 mb-20">
                    <ul>
                      {checklist.map((item, idx) => (
                        <li key={idx}>
                          <i className="fas fa-angle-double-right" /> {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* SIDEBAR COLUMN */}
          <div className="col-xxl-4 col-lg-5">
            <aside className="sidebar-area">
              <div className="widget widget_service-list">
                <h3 className="widget_title">Otros Servicios de Chapa</h3>
                <ul>
                  <li>
                    <Link to="/chapa-y-pintura/reparacion-siniestros">
                      <i className="fas fa-angle-double-right" />
                      Reparación de Siniestros
                    </Link>
                  </li>
                  <li>
                    <Link to="/chapa-y-pintura/cambio-de-color">
                      <i className="fas fa-angle-double-right" />
                      Cambio de Color
                    </Link>
                  </li>
                  <li>
                    <Link to="/chapa-y-pintura/carroceria-motocicletas">
                      <i className="fas fa-angle-double-right" />
                      Carrocería en Motocicletas
                    </Link>
                  </li>
                  <li>
                    <Link to="/chapa-y-pintura/lunas-y-cristales">
                      <i className="fas fa-angle-double-right" />
                      Lunas y Cristales
                    </Link>
                  </li>
                  <li>
                    <Link to="/chapa-y-pintura/reparacion-llantas">
                      <i className="fas fa-angle-double-right" />
                      Reparación de Llantas
                    </Link>
                  </li>
                  <li>
                    <Link to="/chapa-y-pintura/franquiciados-y-no-franquiciados">
                      <i className="fas fa-angle-double-right" />
                      Franquiciados y No Franquiciados
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="widget widget_contact">
                <div className="widget-contact-wrap text-center">
                  <h3 className="widget_title">Contáctanos</h3>
                  <p className="widget-contact-text">
                    Solicita información adicional o un presupuesto sin compromiso. 
                    Estaremos encantados de atenderte.
                  </p>
                  <div className="icon">
                    <i className="fas fa-phone-alt" />
                  </div>
                  <p className="widget-contact-text">¿Necesitas ayuda?</p>
                  <h5>
                    <Link to="https://wa.me/+34698925394" onClick={trackWhatsAppContact}>(+34) 698 92 53 94</Link>
                  </h5>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceDetails;
